import React from "react";
import { FaTv } from "react-icons/fa6";
import { Link } from "react-router-dom";
import logo from "../../images/logo.jpg";

const Sidebar = () => {
  return (
    <div className="bg-white p-3">
      <Link
        to={"/user-table"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 rounded-1 px-4"
      >
        <FaTv className="text_maincolor" />{" "}
        <p className="mb-0 fs-14">User Table</p>
      </Link>{" "}
      <Link
        to={"/upload-banner"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 rounded-1 px-4"
      >
        <FaTv className="text_maincolor" />{" "}
        <p className="mb-0 fs-14">Upload Banner</p>
      </Link>{" "}
      <Link
        to={"/add-services"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 rounded-1 px-4"
      >
        <FaTv className="text_maincolor" />
        <p className="mb-0 fs-14">Add Services</p>
      </Link>{" "}
      <Link
        to={"/all-services"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 rounded-1 px-4"
      >
        <FaTv className="text_maincolor" />
        <p className="mb-0 fs-14">All Services</p>
      </Link>{" "}
      <Link
        to={"/user-orders-admin"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 rounded-1 px-4"
      >
        <FaTv className="text_maincolor" />{" "}
        <p className="mb-0 fs-14">All Orders</p>
      </Link>{" "}
      <Link
        to={"/user-trials"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 rounded-1 px-4"
      >
        <FaTv className="text_maincolor" />{" "}
        <p className="mb-0 fs-14">All Trials</p>
      </Link>{" "}
      <Link
        to={"/coupon"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 rounded-1 px-4"
      >
        <FaTv className="text_maincolor" />{" "}
        <p className="mb-0 fs-14">Add Coupon</p>
      </Link>{" "}
      <Link
        to={"/add-blogs"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 rounded-1 px-4"
      >
        <FaTv className="text_maincolor" />{" "}
        <p className="mb-0 fs-14">Add Blogs</p>
      </Link>{" "}
      <Link
        to={"/all-blogs"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 rounded-1 px-4"
      >
        <FaTv className="text_maincolor" />{" "}
        <p className="mb-0 fs-14">All Blogs</p>
      </Link>{" "}
      <Link
        to={"/admin-coupon"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 rounded-1 px-4"
      >
        <FaTv className="text_maincolor" />{" "}
        <p className="mb-0 fs-14">Manage Coupons</p>
      </Link>{" "}
    </div>
  );
};

export default Sidebar;
